import React from 'react';
import Button from '../../../components/ui/Button';

const ActionButtons = ({ 
  order, 
  onPrintReceipt, 
  onMarkDelivered, 
  isPrinting, 
  isMarking 
}) => {
  if (!order) return null;

  const canMarkDelivered = order?.status === 'Lista';
  const balance = order?.balance || 0;

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 p-4 md:p-6">
      <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">
        Acciones
      </h3>

      <div className="space-y-3">
        <Button
          variant="outline"
          iconName="Printer"
          iconPosition="left"
          onClick={onPrintReceipt}
          loading={isPrinting}
          fullWidth
        >
          Imprimir Ticket
        </Button>

        {canMarkDelivered && balance === 0 && (
          <Button
            variant="success"
            iconName="CheckCircle"
            iconPosition="left"
            onClick={onMarkDelivered}
            loading={isMarking}
            fullWidth
          >
            Marcar como Entregada
          </Button>
        )}

        {canMarkDelivered && balance > 0 && (
          <div className="bg-warning/10 rounded-lg p-3">
            <p className="text-xs md:text-sm text-warning text-center">
              Complete el pago para marcar como entregada
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionButtons;